

// import React, { useEffect, useState } from 'react'
// import { Grid } from '@mui/material';
// import CustomTable from '../../../Components/Table/CustomTable';
// import UserCreateByOperatorModal from '../Modal/UserCreateByOperatorModal';
// import { useDispatch, useSelector } from 'react-redux';
// import { setHeaderName } from '../../../ReduxStore/Slices/headerSlice';
// import TableDataViewModal from '../Modal/TableDataViewModal';
// import actions from '../../../ReduxStore/actions';
// // import { setHeaderName } from './headerSlice';


// const TotalOnboarding = ({ setHeaderTitleName }) => {

//   const dispatch = useDispatch()
//   const tableData = [
//     { Name: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "1232343444", UserType: "Individual", Status: "Approved" },
//     { Name: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "98787687687", UserType: "Individual", Status: "Approved" },
//     { Name: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "123322443543", UserType: "Individual", Status: "Approved" },
//     { Name: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "76575675664", UserType: "Individual", Status: "Approved" },
//     { Name: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "909878789709", UserType: "Financial Consultant", Status: "Pending" },



//   ];

//   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
//   const UserRole = sessionStorage.getItem("UserRole");


//   useEffect(() => {
//     // setHeaderTitleName("User Registration")
//     dispatch(setHeaderName("Total Onboarding"));
//   }, [])
//   const tableHeadData = ['S.No', 'Name', "Email Id", "Mobile Number", "User Type", 'Status'];


//   const { getCustomersByCreator } = useSelector(
//     (state) => state?.getCustomersByCreator
//   );

//   useEffect(() => {
//     const data1 = {
//       data: {
//         createdByUserId: sessionOperator_id,
//         createdByUserRole: UserRole,
//       },
//       method: "get",
//       apiName: "getCustomersByCreator",
//     };

//     dispatch(actions.GETCUSTOMERSBYCREATOR(data1));
//   }, [dispatch]);

//   const [rowTableData, setRowTableData] = useState([
//     {
//       Name: "--",
//       Email: "--",
//       MobileNumber: "--",
//       UserType: "--",
//       Status: "--",
//     },
//   ]);
//   console.log(rowTableData, "rowTableDatarowTableData");
//   useEffect(() => {
//     const tempArr = [];
//     getCustomersByCreator?.data?.map((data, index) => {
//       return tempArr.push({
//         Name: `${data?.first_name} ${data?.last_name}`,
//         Email: data?.email,
//         MobileNumber: data?.phone,
//         // UserType: data?.role,
//         UserType: data?.role ? data?.role?.charAt(0).toUpperCase() + data?.role?.slice(1) : "",



//         Status:
//           data?.approval_status === "pending"
//             ? "Pending"
//             : data?.approval_status === "approved"
//               ? "Approved"
//               : "Unknown", // Add a default case if needed
//       });
//     });
//     setRowTableData(tempArr);
//   }, [dispatch, getCustomersByCreator]);


//   return (
//     <Grid container spacing={2}>

//       <Grid item xs={12} sx={{ width: "100px" }}>
//         <CustomTable tableData={rowTableData} title="User List" tableHeadData={tableHeadData}
//           rowPerPage={10}
//           tableView="tableView"
//           tableSearch="tableSearch"
//           // dataCreate={false}
//           // tableEdit="tableEdit"
//           // tableDelete="tableDelete"
//           modalName={UserCreateByOperatorModal}
//           // allShowModal="allShowModal"
//           modalVeiwName={TableDataViewModal}
//           notModalTable="notModalTable"
//           modalViewHeadingName="User Detail"

//           modalHeadingName="Create User"
//         />

//       </Grid>
//     </Grid>
//   )
// }

// export default TotalOnboarding




import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material';
import CustomTable from '../../../Components/Table/CustomTable';
import UserCreateByOperatorModal from '../Modal/UserCreateByOperatorModal';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import TableDataViewModal from '../Modal/TableDataViewModal';
import actions from '../../../ReduxStore/actions';
// import { setHeaderName } from './headerSlice';


const TotalOnboarding = ({ setHeaderTitleName }) => {

  const dispatch = useDispatch()
  const tableData = [
    { Name: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "1232343444", UserType: "Individual", Status: "Approved" },
    { Name: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "98787687687", UserType: "Individual", Status: "Approved" },
    { Name: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "123322443543", UserType: "Individual", Status: "Approved" },
    { Name: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "76575675664", UserType: "Individual", Status: "Approved" },
    { Name: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "909878789709", UserType: "Financial Consultant", Status: "Pending" },



  ];

  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("UserRole");


  useEffect(() => {
    // setHeaderTitleName("User Registration")
    dispatch(setHeaderName("Total Onboarding"));
  }, [])
  const tableHeadData = ['S.No', 'Name', "Email Id", "Mobile Number", "User Type", 'Status'];


  const { getCustomersByCreator } = useSelector(
    (state) => state?.getCustomersByCreator
  );

  useEffect(() => {
    const data1 = {
      data: {
        createdByUserId: sessionOperator_id,
        createdByUserRole: UserRole,
      },
      method: "get",
      apiName: "getCustomersByCreator",
    };

    dispatch(actions.GETCUSTOMERSBYCREATOR(data1));
  }, [dispatch]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      Email: "--",
      MobileNumber: "--",
      UserType: "--",
      Status: "--",
    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getCustomersByCreator?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.first_name} ${data?.last_name}`,
        customer_id:data?.customer_id || "--",
        Email: data?.email,
        MobileNumber: data?.phone,
        // UserType: data?.role,
        UserType: data?.role ? data?.role?.charAt(0).toUpperCase() + data?.role?.slice(1) : "",



        Status:
          data?.approval_status === "pending"
            ? "Pending"
            : data?.approval_status === "approved"
              ? "Approved"
              : "Unknown", // Add a default case if needed
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getCustomersByCreator]);


  return (
    <Grid container spacing={2}>

      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable tableData={rowTableData} title="User List" tableHeadData={tableHeadData}
          rowPerPage={10}
          tableView="tableView"
          tableSearch="tableSearch"
          // dataCreate={false}
          // tableEdit="tableEdit"
          // tableDelete="tableDelete"
          modalName={UserCreateByOperatorModal}
          allShowModal="allShowModal"
          modalVeiwName={TableDataViewModal}
          notModalTable="notModalTable"
          modalViewHeadingName="User Detail"

          modalHeadingName="Create User"
        />

      </Grid>
    </Grid>
  )
}

export default TotalOnboarding